import { importProvidersFrom } from '@angular/core';
import { Routes } from '@angular/router';
import { ModalModule } from 'ngx-bootstrap/modal';
export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./home/home.component').then((mod) => mod.HomeComponent),
  },
  { path: 'en-au', redirectTo: '', pathMatch: 'full' },
  { path: 'en-au/p/:slug', redirectTo: 'p/:slug' },
  { path: 'en-au/booknow', redirectTo: 'booknow', pathMatch: 'full' },
  { path: 'en-au/booknow/:slug', redirectTo: 'booknow/:slug' },
  {
    path: 'our-vehicles',
    loadChildren: () =>
      import('./vehicle/vehicle.routes').then((routes) => routes.routes),
    data: { preload: true },
  },
  {
    path: 'campervan-hire-locations',
    loadChildren: () =>
      import('./location/location.routes').then((routes) => routes.routes),
    data: { preload: true },
  },
  //unpublished location routes
  {
    path: 'campervan-hire-airlie-beach',
    loadComponent: () =>
      import(`./location/airlie-beach/airlie-beach.component`).then((mod) => mod.AirlieBeachComponent),
  },
  // SEO-friendly short URLs for major cities - PRIMARY URLs
  {
    path: 'campervan-hire-melbourne',
    loadComponent: () =>
      import('./location/location-detail/location-detail.component').then((mod) => mod.LocationDetailComponent),
    data: { cat: 'victoria', slug: 'melbourne' },
  },
  {
    path: 'campervan-hire-sydney',
    loadComponent: () =>
      import('./location/location-detail/location-detail.component').then((mod) => mod.LocationDetailComponent),
    data: { cat: 'new-south-wales', slug: 'sydney' },
  },
  {
    path: 'campervan-hire-brisbane',
    loadComponent: () =>
      import('./location/location-detail/location-detail.component').then((mod) => mod.LocationDetailComponent),
    data: { cat: 'queensland', slug: 'brisbane' },
  },
  {
    path: 'campervan-hire-cairns',
    loadComponent: () =>
      import('./location/location-detail/location-detail.component').then((mod) => mod.LocationDetailComponent),
    data: { cat: 'queensland', slug: 'cairns' },
  },
  {
    path: 'campervan-hire-perth',
    loadComponent: () =>
      import('./location/location-detail/location-detail.component').then((mod) => mod.LocationDetailComponent),
    data: { cat: 'western-australia', slug: 'perth' },
  },
  {
    path: 'campervan-hire-adelaide',
    loadComponent: () =>
      import('./location/location-detail/location-detail.component').then((mod) => mod.LocationDetailComponent),
    data: { cat: 'south-australia', slug: 'adelaide' },
  },
  {
    path: 'campervan-hire-darwin',
    loadComponent: () =>
      import('./location/location-detail/location-detail.component').then((mod) => mod.LocationDetailComponent),
    data: { cat: 'northern-territory', slug: 'darwin' },
  },
  {
    path: 'campervan-hire-hobart',
    loadComponent: () =>
      import('./location/location-detail/location-detail.component').then((mod) => mod.LocationDetailComponent),
    data: { cat: 'tasmania', slug: 'hobart' },
  },
  {
    path: 'campervan-hire-alice-springs',
    loadComponent: () =>
      import('./location/location-detail/location-detail.component').then((mod) => mod.LocationDetailComponent),
    data: { cat: 'northern-territory', slug: 'alice-springs' },
  },
  {
    path: 'campervan-hire-gold-coast',
    loadComponent: () =>
      import('./location/location-detail/location-detail.component').then((mod) => mod.LocationDetailComponent),
    data: { cat: 'queensland', slug: 'gold-coast' },
  },
  {
    path: 'campervan-hire-broome',
    loadComponent: () =>
      import('./location/location-detail/location-detail.component').then((mod) => mod.LocationDetailComponent),
    data: { cat: 'western-australia', slug: 'broome' },
  },
  {
    path: 'campervan-hire-exmouth',
    loadComponent: () =>
      import('./location/location-detail/location-detail.component').then((mod) => mod.LocationDetailComponent),
    data: { cat: 'western-australia', slug: 'exmouth' },
  },
  {
    path: 'bookings',
    loadChildren: () =>
      // Before migration: import('./bookings/bookings.routes').then((routes) => routes.routes),
      import('./book-rentalkit/book-rentalkit.routes').then((routes) => routes.routes),
  },
  // {
  //   path: 'book-rentalkit',
  //   providers: [importProvidersFrom(ModalModule.forRoot())],
  //   loadChildren: () =>
  //     import('./book-rentalkit/book-rentalkit.routes').then(
  //       (routes) => routes.routes,
  //     ),
  // },
  {
    path: 'car-hire',
    loadChildren: () =>
      import('./car-hire/car-hire.routes').then((routes) => routes.routes),
  },
  {
    path: 'trip-ideas',
    loadChildren: () =>
      import('./trip-ideas/trip-ideas.routes').then((routes) => routes.routes),
  },
  {
    path: 'relocation',
    loadComponent: () =>
      import('./relocation/relocation.component').then(
        (mod) => mod.RelocationComponent
      ),
  },
  {
    path: 'policies',
    loadComponent: () =>
      import('./pages/pages.component').then(
        (mod) => mod.PagesComponent
      ),
    data: { slug: 'wicked-rental-policies' },
  },
  {
    path: 'policies/vehicle-rental-agreement/embed',
    loadComponent: () =>
      import('./pages/documents/vra/vra.component').then((mod) => mod.VraComponent),
    data: { embedded: true },
  },
  {
    path: 'policies/vehicle-rental-agreement',
    loadComponent: () =>
      import('./pages/documents/vra/vra.component').then((mod) => mod.VraComponent),
  },
  {
    path: 'policies/privacy-policy',
    loadComponent: () =>
      import('./pages/documents/privacy-policy/privacy-policy.component').then((mod) => mod.PrivacyPolicyComponent),
  },
  {
    path: 'policies/sms-terms',
    loadComponent: () =>
      import('./pages/documents/sms-terms/sms-terms.component').then((mod) => mod.SmsTermsComponent),
  },
  {
    path: 'contact-us',
    loadComponent: () =>
      import('./contact/contact.component').then((mod) => mod.ContactComponent),
  },
  { path: 'p/become-an-agent', redirectTo: '/contact-us#become-an-agent', pathMatch: 'full' },
  { path: 'p/wicked-rental-policies', redirectTo: '/policies', pathMatch: 'full' },
  { path: 'p/campervan-hire-guide', redirectTo: '/campervan-hire', pathMatch: 'full' },
  {
    path: 'p/about-us',
    loadComponent: () =>
      import('./pages/about-us/about-us.component').then(
        (mod) => mod.AboutUsComponent
      ),
  },
  {
    path: 'p/:slug',
    loadComponent: () =>
      import('./pages/pages.component').then((mod) => mod.PagesComponent),
  },
  {
    path: 'booknow',
    loadComponent: () =>
      import('./booknow/booknow.component').then((mod) => mod.BooknowComponent),
  },
  {
    path: 'booknow/:slug',
    loadComponent: () =>
      import('./booknow/booknow.component').then((mod) => mod.BooknowComponent),
  },
  {
    path: 'blog',
    loadChildren: () =>
      import('./blog/blog.routes').then((routes) => routes.routes),
  },
  {
    path: 'specials',
    loadChildren: () =>
      import('./specials/specials.routes').then((routes) => routes.routes),
  },
  {
    path: 'help',
    loadComponent: () =>
      import('./pages/help/help.component').then((mod) => mod.HelpComponent),
  },
  {
    path: 'flexi-pass',
    loadComponent: () =>
      import('./pages/flexi-pass/flexi-pass.component').then(
        (mod) => mod.FlexiPassComponent
      ),
  },
  // {
  //   path: 'trust-pricing-guide',
  //   loadComponent: () =>
  //     import('./pages/trust-pricing/trust-pricing.component').then(
  //       (mod) => mod.TrustPricingComponent
  //     ),
  // },
  // {
  //   path: 'vehicle-standards',
  //   loadComponent: () =>
  //     import('./pages/vehicle-standards/vehicle-standards.component').then(
  //       (mod) => mod.VehicleStandardsComponent
  //     ),
  // },
  // {
  //   path: 'pricing-bond-refunds',
  //   loadComponent: () =>
  //     import('./pages/pricing-bond-refunds/pricing-bond-refunds.component').then(
  //       (mod) => mod.PricingBondRefundsComponent
  //     ),
  // },
  // {
  //   path: 'family-eco-camper-options',
  //   loadComponent: () =>
  //     import('./pages/family-eco-camper-options/family-eco-camper-options.component').then(
  //       (mod) => mod.FamilyEcoCamperOptionsComponent
  //     ),
  // },
  // {
  //   path: '4wd-hire-locations-australia',
  //   loadComponent: () =>
  //     import('./pages/fourwd-hire-locations/fourwd-hire-locations.component').then(
  //       (mod) => mod.FourwdHireLocationsComponent
  //     ),
  // },
  {
    path: 'campervan-hire',
    loadComponent: () =>
      import('./pages/campervan/campervan.component').then(
        (mod) => mod.CampervanComponent
      ),
  },
  {
    path: '404',
    loadComponent: () =>
      import('./page-not-found/page-not-found.component').then(
        (mod) => mod.PageNotFoundComponent
      ),
  },
  // routes for diagnostic precheck - enable when need diagnostic
  // {
  //   path: 'diag',
  //   loadComponent: () =>
  //     import('./components/diag/diag.component').then(
  //       (mod) => mod.DiagComponent
  //     ),
  // },
  {
    path: '**',
    loadComponent: () =>
      import('./page-not-found/page-not-found.component').then(
        (mod) => mod.PageNotFoundComponent
      ),
  },
];
